import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sayfa yolu her değiştiğinde tarayıcıyı en başa (0,0) ışınlar
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;